import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jira-icon",
  "use": "icon-jira-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jira-icon\">\n<path d=\"M17.8527 11.675L12.5157 6.50727L11.9918 6L7.9809 9.88375L6.14734 11.675C5.95089 11.8653 5.95089 12.1664 6.14734 12.3408L9.81446 15.8917L11.9918 18L16.0027 14.1162L16.0682 14.0528L17.8527 12.3408C18.0491 12.1506 18.0491 11.8494 17.8527 11.675ZM11.9918 13.7834L10.1583 12.0079L11.9918 10.2325L13.8254 12.0079L11.9918 13.7834Z\" fill=\"#2684FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol